<script setup lang="ts">
import type { TasksKanbanCardHeaderProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'

defineOptions({
  name: 'TasksKanbanCardHeader',
})

defineProps<TasksKanbanCardHeaderProps>()
</script>

<template>
  <div class="task-card__header">
    <AppText
      name="body2"
      color="slate-500"
      class="task-card__id"
    >
      #{{ taskId }}
    </AppText>
    <div class="task-card__name">
      <AppTooltip
        :text="taskName"
        placement="top"
        size="small"
      >
        <AppText
          name="body2-medium"
          color="slate-900"
        >
          {{ taskName }}
        </AppText>
      </AppTooltip>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_tasks-kanban-card-header.scss" />
